import { translationNestedEN } from '@tempo-io/translations';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationNestedEN,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  ns: ['translation', 'homepage', 'teams'],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
